import { Stack, Typography } from "@mui/material";
import logo from "../assets/rowlygo_logo_lila_rgb.png"; // Tell webpack this JS file uses this image
import { getImgHostingUrl } from "../utilities";
export default function UrentLogo() {
  return (
    <>
      <a
        style={{ fontSize: "13px", textDecoration: "none", color: "black" }}
        href="https://rowlygo.fi"
        target="_blank"
      >
        <Stack direction={"row"} alignItems={"center"}>
          <Typography sx={{ fontSize: "12px", marginBottom: "2px" }}>
            Powered by
          </Typography>
          <img
            style={{
              height: "40px",
              objectFit: "contain",
            }}
            src={getImgHostingUrl(logo)}
            alt="Powered by Rowly Go"
          />
        </Stack>
      </a>
    </>
  );
}
